module.exports = __webpack_public_path__ + "img/antenna-04.3b10951f.svg";